import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConsentProvider } from "@/lib/consent";
import useLenis, { getLenis } from "@/hooks/useLenis";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Contractors from "@/pages/Contractors";
import Agencies from "@/pages/Agencies";
import Pricing from "@/pages/Pricing";
import Faq from "@/pages/Faq";
import GetStarted from "@/pages/GetStarted";
import Privacy from "@/pages/legal/Privacy";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import Terms from "@/pages/legal/Terms";
import Accessibility from "@/pages/legal/Accessibility";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const l = getLenis();
    if (l) {
      l.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function AppRoutes() {
  useLenis();
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/contractors" element={<Contractors />} />
          <Route path="/agencies" element={<Agencies />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <ConsentProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" />
      </BrowserRouter>
    </ConsentProvider>
  );
}
